<div class="mb-3">
  <app-minimum-dispatch-time></app-minimum-dispatch-time>
</div>

<form class="cx-place-order-form form-check" [formGroup]="checkoutSubmitForm">
  <div class="form-group row preferred-date">
    <div class="col-12">
      <label>
        <ng-template #tipContent>
          <div class="preferred-date-hint">
            <span>{{ 'checkoutShipping.preferredDateHint' | cxTranslate }}</span>
          </div>
        </ng-template>
        <span class="label-content"
          >{{ 'checkoutShipping.preferredDate' | cxTranslate }}
          <i class="fas fa-info-circle info-icon" [ngbTooltip]="tipContent"></i>
        </span>
        <input
          [matDatepicker]="picker"
          [min]="minDate"
          aria-label="preferred-date"
          class="form-control"
          type="text"
          name="preferredDate"
          placeholder="Enter dispatch date"
          [matDatepickerFilter]="holidaysAndDeliverydaysFilter"
          formControlName="requestedDeliveryDate"
          readonly
          />
          <mat-datepicker #picker></mat-datepicker>
        </label>
        <button type="button" class="btn preferred-date__search-icon" (click)="openDatePicker(); picker.open()">
          <i class="fas fa-calendar-alt"></i>
        </button>
      </div>
    </div>
    <div class="form-group special-instructions">
      <p class="cx-checkout-title d-lg-block d-xl-block">
        {{ 'checkoutShipping.specialInstructions' | cxTranslate }}
      </p>
      <ng-container>
        <textarea
          class="form-control special-instructions"
          rows="3"
          formControlName="specialInstructions"
          maxlength="200"
          >
        </textarea>
        @if (checkoutSubmitForm?.controls?.specialInstructions) {
          <p class="character-limit">
            {{
            'checkoutShipping.specialInstructionsHint'
            | cxTranslate: { count: 200 - checkoutSubmitForm.controls.specialInstructions.value.length }
            }}
          </p>
        }
      </ng-container>
    </div>
    <div class="form-group">
      <label>
        <input formControlName="termsAndConditions" class="scaled-input form-check-input" type="checkbox" />
        <span class="form-check-label">
          {{ 'checkoutReview.confirmThatRead' | cxTranslate }}
          <a (click)="getTermsAndConditions($event)" class="cx-tc-link" target="_blank">
            {{ 'checkoutReview.termsAndConditions' | cxTranslate }}
          </a>
        </span>
      </label>
    </div>

    @if (sharedService.getUser() | async) {
      @if (sharedService.isUserCreditHold) {
        <app-credit-hold-message> </app-credit-hold-message>
      }
    }

    <button
      (click)="submitForm()"
      class="btn btn-primary btn-block"
      [disabled]="disableOnCreditHoldOrInvalidTerms || (daysOfWeekNotChecked$ | async)"
      >
      {{ 'checkoutReview.placeOrder' | cxTranslate }}
    </button>
  </form>
